<nz-result nzStatus="404" nzTitle="404" [nzSubTitle]="'NOT_FOUND.NOT_FOUND' | translate">
  <div nz-result-extra>
    <button nz-button routerLink="/" nzType="primary">
      {{ 'NOT_FOUND.GO_HOME' | translate }}
    </button>
  </div>
</nz-result>
